import { config } from '@/pageConfig/legalStuff/fr/en';
import { LegalStuffPageTemplate } from '@/pageTemplate/LegalStuffPageTemplate';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import { LegalStuff } from 'contentlayer/generated';
import { useEffect } from 'react';
import content from '../../../../.contentlayer/generated/LegalStuff/legalStuff__en-FR.mdx.json';

export default function LegalStuffPage() {
  const { trackEvent } = useAnalyticsContext();
  // biome-ignore lint/correctness/useExhaustiveDependencies: we just one it on load so no need to add it as a dependency
  useEffect(() => {
    trackEvent('legal_stuff_page.viewed');
  }, []);

  return <LegalStuffPageTemplate config={config} content={content as LegalStuff} />;
}
